import { createAction } from 'redux-act';

import { RegularHour } from '../../../models/interfaces/Hours';
import { SeatedReservation } from '../../../models/interfaces/reservation/Reservation';

export interface SaveRegularHoursPayload {
  placeUuid: string;
  regularHours: RegularHour[];
}
export const saveRegularHours = createAction<SaveRegularHoursPayload>('SAVE_REGULAR_HOURS');

export interface RegularHoursSavedPayload {
  placeUuid: string;
  regularHours: RegularHour[];
  affectedReservations: SeatedReservation[];
}
export const regularHoursSaved = createAction<RegularHoursSavedPayload>('REGULAR_HOURS_SAVED');

export interface RegularHoursSaveFailedPayload {
  placeUuid: string;
}
export const regularHoursSaveFailed = createAction<RegularHoursSaveFailedPayload>('REGULAR_HOURS_SAVE_FAILED');
